import { api } from './client';

export interface NpsIn {
  score: number; // 0–10
  comment?: string | null;
}

export interface NpsOut {
  id: string;
  session_id: string;
  station_id: string;
  score: number;
  comment: string | null;
  created_at: string;
}

export const feedbackApi = {
  /**
   * Envia a nota NPS de uma sessão concluída. Idempotente: reenviar para a
   * mesma sessão devolve a nota já existente (backend não duplica).
   */
  submitNps: (sessionId: string, body: NpsIn) =>
    api.post<NpsOut>(`/feedback/sessions/${sessionId}/nps`, body)
};
